import { render } from "./EthLogo.vue?vue&type=template&id=ad4ea9f4&scoped=true"
const script = {}

import "./EthLogo.vue?vue&type=style&index=0&id=ad4ea9f4&scoped=true&lang=scss"

import exportComponent from "/Users/giovannivignone/VSCodeProjects/mintSiteAMJ-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad4ea9f4"]])

export default __exports__